import { BaseSelectableItem } from "../types/forms";
import MultipleChoiceOptionNumericId from "../types/forms/MultipleChoiceOptions";

export type SliderThemeName = "WHITE" | "STANDARD" | "THEMED";

/** True when trimmed label begins with a digit — "2" and "1 - not so good" yes, "Low" no. */
export const labelStartsWithDigit = (text: string): boolean =>
  /^\d/.test(text.trim());

/**
 * True for word-only Likert scales — triggers tile-button UI in Slider.
 * Slider track when any label is empty, every label starts with a digit, or labels are mixed.
 */
export const shouldRenderSliderAsRadioButtons = (
  scalePoints: BaseSelectableItem[],
): boolean => {
  if (scalePoints.length === 0) {
    return false;
  }

  const labels = scalePoints.map((point) => point.text?.trim() ?? "");

  if (labels.some((label) => label.length === 0)) {
    return false;
  }

  return labels.every((label) => !labelStartsWithDigit(label));
};

export const toFormRadioButtonOptions = (
  scalePoints: BaseSelectableItem[],
): MultipleChoiceOptionNumericId[] =>
  scalePoints.map((point) => {
    const existingOptionId = (
      point as Partial<MultipleChoiceOptionNumericId>
    ).optionId;

    return {
      ...point,
      optionId:
        existingOptionId !== undefined
          ? existingOptionId
          : parseInt(point.value.toString(), 10),
      allowCustomText: false,
    };
  });

export const sliderThemeToRadioBackground = (
  theme: SliderThemeName,
): "DARK" | "LIGHT" => (theme === "WHITE" ? "DARK" : "LIGHT");

const sliderHelper = {
  labelStartsWithDigit,
  shouldRenderSliderAsRadioButtons,
  toFormRadioButtonOptions,
  sliderThemeToRadioBackground,
};

export default sliderHelper;
